"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Pencil01 = function Pencil01(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m2.5 21.4998 5.5493-2.1343c.355-.1365.5324-.2048.6984-.2939a3 3 0 0 0 .4203-.2732c.149-.1155.2834-.25.5523-.5189L21 6.9998c1.1046-1.1045 1.1046-2.8954 0-4s-2.8954-1.1046-4 0L5.7203 14.2795c-.269.2689-.4034.4034-.519.5523a3 3 0 0 0-.273.4203c-.0892.166-.1574.3435-.294.6985zm0 0 2.0581-5.351c.1473-.3829.221-.5744.3472-.6621a.5.5 0 0 1 .379-.0804c.151.0288.296.1739.5862.464l2.259 2.2591c.2902.2901.4352.4351.464.5861a.5.5 0 0 1-.0804.379c-.0876.1263-.2791.1999-.662.3472z"
    })
  }));
};
var _default = exports["default"] = Pencil01;